import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Typography from '@mui/material/Typography'
// import TabComp from '../components/Tabs/TabComp';
import Button from '@mui/material/Button';
// import TextField from '@mui/material/TextField';
import SmallCards from '../components/Cards/SmallCards';
// import Cards from '../components/Cards/Cards';
// import { Checkbox, FormControl, MenuItem, Select } from '@mui/material';
// import ProductGallery from '../components/product/ProductGallery';
// import ContentCard from '../components/Cards/ContentCard';
// import BigCard from '../components/Cards/BigCard';
// import ProductGallery from '../components/product/ProductGallery';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hook/Translation';
import Accordions from '../components/Accordions/Accordions';
export default function TargetedLaserSkinTherapies() {
    const { t } = useTranslation();

    const data = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('targeted_laser_skin_therapies.time')
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('targeted_laser_skin_therapies.discomfort')
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('targeted_laser_skin_therapies.downtime')
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('targeted_laser_skin_therapies.sessions')
        }
    ]

    const accodirons = [
        {
            title: t('what'),
            content: t('targeted_laser_skin_therapies.what'),
        },
        {
            title: t('how'),
            content: t('targeted_laser_skin_therapies.how'),
        },
        {
            title: t('benefits'),
            content: t('targeted_laser_skin_therapies.benefits'),
        },
        {
            title: t('zone'),
            content: t('targeted_laser_skin_therapies.zone'),
        },
        {
            title: t('healingTime'),
            content: t('targeted_laser_skin_therapies.pairs'),
        },
        {
            title: t('when_expected_results'),
            content: t('targeted_laser_skin_therapies.expected_results'),
        },
    ];

    return (
        <Box>
            <HalfSizeBanner height={{ md: '460px', xs: 'auto' }}>
                <Box sx={{ height: '100%', backgroundImage: 'linear-gradient(90deg, rgb(30, 53, 61) 50%, rgba(30, 53, 61, 0) 100%)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', display: 'flex', justifyContent: 'center', alignItems: 'center' }} position={'relative'}>
                    <Grid container marginX={'auto'} spacing={12} paddingY={{ md: 'unset', xs: '30px' }} height={1} width={{ md: 1, xs: '90%' }}>
                        <Grid size={{ md: 6, xs: 12 }} height={1} position={'relative'} zIndex={2}>
                            <Grid container spacing={4} flexDirection={'column'} justifyContent={'center'} height={1} alignItems={{ md: 'end', xs: 'start' }}>
                                <Grid size={'auto'}>
                                    <Typography sx={{ width: { md: '550px', xs: '100%' } }} className='wColor' variant='h1' fontSize={{ md: '2.875rem', xs: '2rem' }} fontWeight={'bold'} fontFamily={'DanmarkURW'}>{t('targeted_laser_skin_therapies.mainTitle')}</Typography>
                                </Grid>
                                <Grid size={'auto'}>
                                    <Typography sx={{ width: { md: '550px', xs: '100%' } }} className='wColor' variant='h1' fontSize={{ md: '18px', xs: '1rem' }} fontWeight={'500'}>
                                        Vajza:
                                        <br />
                                        {`${t('price_session')} 350€`}
                                        {/* // price: `${t('price_session')} €350\n${t('price_package')} 4 ${t('price_seanc')}: €950` */}

                                        <br />
                                        {`${t('price_package')} 4 ${t('price_seanc')}: 1050€ ${t('free_session')}`}
                                    </Typography>
                                    <Typography sx={{ width: { md: '550px', xs: '100%' }, mt: 2 }} className='wColor' variant='h1' fontSize={{ md: '18px', xs: '1rem' }} fontWeight={'500'}>
                                        Djem:
                                        <br />
                                        {`${t('price_session')} 450€`}
                                        <br />
                                        {`${t('price_package')} 4 ${t('price_seanc')}: 1350€ ${t('free_session')}`}
                                        {/* // price: `${t('price_session')} €350\n${t('price_package')} 4 ${t('price_seanc')}: €950` */}

                                    </Typography>
                                </Grid>
                                <Grid size={'auto'}>
                                    <Typography sx={{ width: { md: '550px', xs: '100%' } }} className='wColor' variant='h1' fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'500'}>{t('targeted_laser_skin_therapies.mainDesc')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }} height={1} position={{ md: 'relative', xs: 'absolute' }} width={1} top={{ md: 'unset', xs: 0 }} left={{ md: 'unset', xs: 0 }} sx={{ opacity: { md: 1, xs: 0.6 } }}>
                            <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08ee034a8e3.16128838.jpg`} height={1} width={1} className='fitCover' />
                        </Grid>
                    </Grid>
                </Box>
            </HalfSizeBanner>

            <Box marginTop={{ md: '90px', xs: '50px' }}>
                <Box className='generalContainer' marginX={'auto'}>
                    <Grid container spacing={{ md: 8, xs: 2 }} position={'relative'} height={{ md: 400, xs: 'auto' }} padding={{ md: 'unset', xs: '20px' }} flexDirection={{ md: 'row', xs: 'column-reverse' }}>
                        <Grid size={{ md: 6, xs: 12 }} position={{ md: 'relative', xs: 'unset' }} width={1} height={1} zIndex={{ md: 'unset', xs: 1 }} sx={{ opacity: { md: 1, xs: 1 } }}>
                            <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 8.png`} className='fitCover' width={1} height={1} />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }} zIndex={2}>
                            <Grid container height={1} justifyContent={'center'} alignItems={'center'}>
                                <Grid size={12} height={'max-content'}>
                                    <Grid container gap={'38px'}>
                                        <Grid size={12}>
                                            <Typography textAlign={'center'} variant="h3" color="text.secondary" fontFamily={'DanmarkURW'} fontSize={{ md: '2.875rem', xs: '2rem' }} fontWeight={'bold'}>{t('targeted_laser_skin_therapies.tech')}</Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '1rem', xs: '0.875rem' }}>{t('targeted_laser_skin_therapies.techDesc')}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12} height={'max-content'} mt={'28px'}>
                                        <Grid container height={1} justifyContent={'center'}>
                                            <Grid size={{ md: 'auto', xs: 12 }}>
                                                <Button LinkComponent={Link} to={`https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Heqja e qimeve")}`} target='_blank' fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton defaultButton buttonTextSize' sx={{ color: 'primary.main', backgroundColor: 'secondary.main' }}>
                                                    {t('book_now')}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Box marginTop={{ md: '205px', xs: '50px' }} className='generalContainer' mx={'auto'}>
                <SmallCards data={data} />
            </Box>
            <Grid container gap={{ md: '80px', xs: '50px' }} className="generalContainer" sx={{ marginX: 'auto', }} marginTop={{ md: '120px', xs: '50px' }} marginBottom={{ md: '110px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            {/* <Box className='generalContainer' marginX={'auto'} marginTop={'124px'}>
                <Typography variant="body1" className='dColor' textAlign={'center'} fontSize={{ md: '1.875rem', xs: '1.25rem' }} fontWeight={'bold'}>
                    All these treatments are quick “spot fixes” with minimal downtime for example, a capillary laser on the face might leave slight redness for a day, and pigment lasers cause darkening then shedding of the spot like coffee ground specks
                </Typography>
            </Box> */}
            {/* 
            <Box sx={{ marginX: 'auto', marginTop: { md: '126px', xs: '' } }}>
                <Box sx={{ height: { md: '520px', xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: '/',
                            learn: '/',
                            title: 'Lymphatic Radiance Boost',
                            imageUrl: '/images/Mask_Group_7.png',
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 9, xs: 12 },
                            flexDirection: { md: "row-reverse", xs: "row" },
                            description: "facial can help flush out debris and calm the skin. For nail fungus, we'll often recommend a good home care regimen in between laser sessions. These laser treatments integrate seamlessly into a personalized skin program, addressing the little imperfections that bother you"
                        }}
                    />
                </Box>
            </Box> */}

            {/* <Grid container gap={'17px'} className="generalContainer" sx={{ marginX: 'auto', marginTop: { md: '102px', xs: '50x' } }}>
                <Grid size={12}>
                    <Grid container justifyContent={'center'}>
                        <Grid size={12}>
                            <Typography textAlign={'center'} fontWeight={600} variant="body1" color="text.secondary" fontSize={'1.125rem'}>Treatment Areas</Typography>
                            <Typography textAlign={'center'} width={{ md: '85%', xs: '100%' }} marginX={'auto'} fontWeight={600} marginTop={'22px'} variant="body1" color="text.secondary" fontSize={'1rem'}>Commonly used on the face (cheeks, nose, chin) for redness and visible vessels, as well as on small angiomas, spider veins on the legs, and sun-related capillaries on the chest and décolleté.</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Cards data={cards} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} />
                </Grid>
            </Grid> */}

            {/* <Box marginTop={{ md: '140px' }}>
                <Grid container gap={{ md: '54px' }} className="generalContainer" marginX={'auto'} marginBottom={{ md: '114px', xs: '50px' }}>
                    <Grid size={12}>
                        <Typography variant="body1" className='dColor' fontSize={'1.125rem'} textAlign={'center'}>Request an Appointement</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Grid container rowSpacing={3}>
                            <Grid size={12}>
                                <Grid container spacing={4}>
                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Firstname' />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Surname' />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <Box sx={inputStyle}>
                                            <FormControl fullWidth sx={inputStyle}>
                                                <Select value={""} displayEmpty sx={{ color: '#728085' }}>
                                                    <MenuItem value="" sx={{ color: '#728085' }}>
                                                        Gender
                                                    </MenuItem>
                                                    <MenuItem value={10} sx={{ color: '#728085' }}>Male</MenuItem>
                                                    <MenuItem value={20} sx={{ color: '#728085' }}>Female</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <Grid container spacing={4}>
                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <Box sx={inputStyle}>
                                            <TextField
                                                fullWidth
                                                type="date"
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Phone' />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='E-Mail' />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <Grid container spacing={4}>
                                    <Grid size={{ md: 4, xs: 12 }}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Birthdate' type='date' />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ md: 8, xs: 12 }}>
                                        <FormControl fullWidth sx={inputStyle}>
                                            <Select value={""} displayEmpty sx={{ color: '#728085' }}>
                                                <MenuItem value="" sx={{ color: '#728085' }}>
                                                    Select Treatment
                                                </MenuItem>
                                                <MenuItem value={10} sx={{ color: '#728085' }}>Ten</MenuItem>
                                                <MenuItem value={20} sx={{ color: '#728085' }}>Twenty</MenuItem>
                                                <MenuItem value={30} sx={{ color: '#728085' }}>Thirty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <Box sx={inputStyle}>
                                    <TextField fullWidth placeholder='Messages' />
                                </Box>
                            </Grid>
                            <Grid size={12}>
                                <Box className="flexCenter" sx={{ svg: { fill: '#728085' } }}>
                                    <Checkbox disableFocusRipple disableRipple disableTouchRipple sx={{ paddingLeft: 0 }} />
                                    <Typography variant="body2" className={'dColor'} sx={{ a: { color: 'text.secondary' } }}>I Accept The <Link to="./policy">Privacy Policy</Link> And T&C's*</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box> */}
        </Box>
    )
}